// ─── Central feature flags ──────────────────────────────────────────────
// Optimised around the Agency Hub (primary module — must stay fast).
// Phase 1 declutter: non-core modules are HIDDEN here. Nothing is deleted —
// flip a flag back to `true` to instantly restore a module and its nav entry.
export const FEATURES = {
  // Core / kept
  agencyHub: true,
  argus: true,        // AI QC — kept per product decision
  fieldAgents: true,  // active
  demo: true,         // sales demos — kept fully visible

  // Hidden in Phase 1 (reversible)
  bot: false,            // Verify Buddy WhatsApp bot + console
  hrmsConnector: false,  // HRMS/ATS connector admin
  hrmsStory: false,      // HRMS story page
  dashboardStudio: false,// Dashboard Studio / CXO overview
  topologyPreview: false,// Topology preview
  sentinel: false,       // Guardian / continuous monitoring
};

export const isEnabled = (key) => FEATURES[key] !== false;
export default FEATURES;
